import React from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
// import Pagination from "react-js-pagination";
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import * as constant from '../../constants/constant';
// import moment from 'moment';
// import Moment from 'react-moment';
// import DatePicker from 'react-datepicker';
import * as dashboardActions from "../../actions/dashboardActions";

// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class SpecialistDocuments extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			logoutButton: false
		}
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this._logout = this._logout.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);

	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	componentWillMount() {
		
		let userObj = {
			code: this.props.location.search.split('&')[1].split("=")[1],
			grant_type: 'authorization_code',
			userId: localStorage.getItem('userId')
		};
		this.props.actions.verifySpecialistStripeAcc(userObj, this.props);
	}

	componentWillReceiveProps(nextProps) {
		// this.setState({
		// 	specialistPatients: nextProps.specialistPatients.myPatient ? nextProps.specialistPatients.myPatient : [],
		// 	totalCount: nextProps.specialistPatients.totalCount ? nextProps.specialistPatients.totalCount : 0,
		// 	isLoader: false
		// })
	}


handleOutsideClick(e) {
	// ignore clicks on the component itself
	if (this.node && this.node.contains(e.target)) {
		return;
	}
	
	this.handleClick();
	}
	handleClick() {
	if (!this.state.logoutButton) {
		// attach/remove event handler
		document.addEventListener('click', this.handleOutsideClick, false);
	} else {
		document.removeEventListener('click', this.handleOutsideClick, false);
	}
	
	this.setState(prevState => ({
		logoutButton: !prevState.logoutButton,
	}));
	}
	render() {
		var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button"> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<div className="tab-content">
											<div className="prescription">
												<div className="boxMrgB">
													<h3>We are verifying and adding your Stripe Account, this may take time, Please dont click back or reload buttons.</h3>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div >
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistPatients: state.specialist.specialistPatients
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistDocuments);